import { Head, Link } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Activity {
  id: number
  title: string
  activity_type: string | null
  activity_date: string | null
  manager: string | null
  status: number
  employees_count: number
  list_items_count: number
}

interface Props {
  activities: Activity[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Marketing Activities", href: "/marketing_activities" },
]

export default function Index({ activities }: Props) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Marketing Activities" />
      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Marketing Activities</h1>
          <Link
            href="/marketing_activities/new"
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add Activity
          </Link>
        </div>
        {activities.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Title
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Type
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Date
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Manager
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {activities.map((activity) => (
                <tr key={activity.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/marketing_activities/${activity.id}`}
                      className="text-hpi-active-blue hover:text-hpi-active-blue"
                    >
                      {activity.title}
                    </Link>
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {activity.activity_type}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {activity.activity_date}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {activity.manager}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/marketing_activities/${activity.id}/edit`}
                      className="text-hpi-active-blue hover:text-hpi-active-blue"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No activities found.</p>
        )}
      </div>
    </AppLayout>
  )
}
